<template>
<div>
  <div class="container" v-if="notAnswered">
    <p class="question">{{ questionObject.question }}</p>
    <div class="m-auto">
      <div class="row text-center m-2" v-for="answerObject in questionObject.answers" :key="answerObject.id">
        <div class="col">
          <button class="btn btn-primary btn-block" @click="answerQuestion(answerObject)">{{ answerObject.answer }}</button>
        </div>
      </div>
    </div>
  </div>
  <transition name="component-fade" mode="out-in">
    <ResponseMaster :response="response" @next="nextQuestion" v-if="!notAnswered"/>
  </transition>
</div>
</template>

<script>

import ResponseMaster from './ResponseMaster'
  
export default {
  name: 'ClassicQuest',
  components: {
    ResponseMaster
  },
  props: {
    questionObject: {
      type: Object,
      required: true
    }
  },
  data() {
    return { 
      notAnswered: true,
      response: "",
      points: 0
    }
  },
  methods: {
    answerQuestion(answer) {
      this.response    = answer.response
      this.points      = answer.points
      this.notAnswered = false
    },
    nextQuestion() {
      this.notAnswered = true
      this.$emit('answer', this.points)
    }
  }
}
</script>
<style scoped>
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .5s ease;
  }
  .component-fade-enter, .component-fade-leave-to {
    opacity: 0;
  }
  .question {
    color: #000;
    font-size: 1.8rem;
    font-weight: 600;
    margin-bottom: 50px;
  }
  .btn-primary {
    background-color: #000000;
    color: rgb(253, 255, 0);
    border: none;
    padding: 5px 15px;
    text-align: center;
  }
  .btn-primary:hover,
  .btn-primary:focus {
    background-color: #000000;
    color: rgb(253, 255, 0);
    border: #fff;
  }
  .btn-block {
    width: 50%;
    margin: 0 auto;
  }
</style>
